import React, { useEffect, useState, useRef } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import Button from "@material-ui/core/Button";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Icon from "@material-ui/core/Icon";
import * as CATEGORY from "../../services/category";
import * as VIDEO from "../../services/video";
import * as FAVOURITE from "../../services/favouriteList";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import { defaultFont } from "assets/jss/material-dashboard-react.js";
import TablePagination from "@material-ui/core/TablePagination";
import { Router, Route, Redirect } from "react-router-dom";
import { themeColor } from "../../assets/jss/material-dashboard-react.js";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import defaultCover from "assets/img/default_cover.png";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import Swal from "sweetalert2";
// import Autocomplete from '@material-ui/lab/Autocomplete';
// import AutoComplete from 'material-ui/AutoComplete';

const styles = makeStyles(theme => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  table: {
    width: "100%",
    overflowX: "auto"
  },
  th: {
    color: themeColor,
    ...defaultFont,
    padding: 4,
    textAlign: "left",
    fontSize: 15.5,
    fontWeight: "400"
  },
  td: {
    ...defaultFont,
    paddingTop: 8,
    paddingBottom: 8,
    // border: '1px solid #ddd',
    padding: 6
  },
  tr: {
    "&:nth-child(even)": {
      backgroundColor: "#f7f7f7"
    },
    "&:hover": {
      backgroundColor: "#e6e6e6",
      cursor: "pointer"
    }
  },
  load: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#AAAAAA !important",
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: themeColor
    }
  },
  disabled: {
    "&:before": {
      backgroundColor: "transparent !important"
    }
  },
  cssLabel: {
    "&$cssFocused": {
      color: themeColor
    }
  },
  cssFocused: {},
  select: {
    marginTop: theme.spacing(3),
    "&:after": {
      borderColor: themeColor
    },
    "&:hover:not($disabled):before": {
      borderColor: themeColor
    }
  }
}));

const listtype = [
  {
    value: "000",
    label: "All"
  },
  {
    value: "100",
    label: "Centre"
  },
  {
    value: "200",
    label: "Class"
  },
  {
    value: "300",
    label: "e-book"
  },
  {
    value: "400",
    label: "Educational Video"
  }
]

const useStyles = styles;
const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.8 + ITEM_PADDING_TOP
    }
  }
};

export default function FavouriteList(props) {
  const classes = useStyles();
  const [userNameSelection, setUserNameSelection] = useState([]);
  const [categorySelection, setCategorySelection] = useState([]);
  const [favouriteList, setFavouriteList] = useState([]);
  const [favouriteCentre, setFavouriteCentre] = useState([]);
  const [favouriteClass, setFavouriteClass] = useState([]);
  const [favouriteBook, setFavouriteBook] = useState([]);
  const [favouriteVideo, setFavouriteVideo] = useState([]);
  const [favouriteAll, setFavouriteAll] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState([]);
  const [selectedUserID, setSelectedUserID] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedType, setSelectedType] = useState("000");
  const [selectedCategory, setSelectedCategory] = useState("-- Select --");
  const [selectedSortby, setSelectedSortby] = useState("-- Select --");
  const [pagination, setPagination] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    props.location.state && props.location.state.currentPage ? props.location.state.currentPage : 1
  );
  const [searchInput, setSearchInput] = useState("");
  const [onFilter, setOnFilter] = useState("");
  const [route, setRoute] = React.useState({});
  const [pageArr, setPageArr] = React.useState([]);
  let myRef;

  const routeTo = (action, id) => {
    setRoute({ action: action, id: id });
  };

  const goToPage = e => {
    setCurrentPage(e.target.value);
    setTimeout(() => {
      document.getElementById("table").scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }, 500);
  };

  let list = []; let userObj = [];
  useEffect(() => {
    let params = {};
    if (onFilter) {
      if (searchInput.length > 0) {
        params.search = searchInput;
      }
      // if (selectedCategory != "-- Select --") {
      //   params.category = selectedCategory;
      // }
      // if (selectedSortby != "-- Select --") {
      //   params.sortby = selectedSortby;
      // }
      if (selectedType != "-- Select --") {
        params.type = selectedType;
      }
    }

    if (props.location.state) {
      if (props.location.state.search) {
        params.search = props.location.state.search;
        setSearchInput(params.search);
        props.location.state.search = null;
      }

      if (props.location.state.type) {
        params.type = props.location.state.type;
        setSelectedType(params.type);
        props.location.state.type = null;
      }
    }
    props.history.replace({
      pathname: "/favourite-list",
      state: {}
    });

    FAVOURITE.getUserList()
    .then(result => {
      // setUserNameSelection(result.data);
      // for (let i = 0; i<result.data.length;i++) {
      //   setUserNameSelection(result.data[i].first_name);
      // }
      // console.log(result.data.length);
      // console.log(result.data[2].first_name + " " + result.data[2].last_name);

    FAVOURITE.getFavouriteList(currentPage, params,selectedType)
      .then(res => {
          if (selectedType == "100") {
            setFavouriteCentre(res.data.data)
          } 
          else if (selectedType == "200") {
            setFavouriteClass(res.data.data);
          }
          else if (selectedType == "400") {
            setFavouriteVideo(res.data.data);
          }
          else if (selectedType == "300"){
            setFavouriteBook(res.data.data);
          }
          else {
            setFavouriteAll(res.data.data);
          }
          // console.log(res.data.data);


            for (let i = 0; i < res.data.data.length; i++) {
            list.push(res.data.data[i].user_id);
            if (result.data.find(user => user.id === res.data.data[i].user_id))
                userObj.push(result.data.find(user => user.id === res.data.data[i].user_id));
            }

            setSelectedUserName(userObj);
            setSelectedUserID(list);
            for (let j=0;j<res.data.data.length;j++) {
              // console.log(userObj[j].first_name);
            }
            // console.log(selectedUserName[0].first_name);

          if (res.data) {
            let page = [];
            for (let i = 0; i < res.data.last_page; i++) {
              page.push(i + 1);
            }
            setPageArr(page);
          }
          setPagination(res.data);
          setLoading(false);
      })
      .catch(err => {
        if (err === "token expired") {
          props.history.replace("/login");
        }
      });
    });

  }, [currentPage, onFilter,selectedType]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
    myRef.scrollIntoView({
      behavior: "auto",
      block: "start"
    });
  };

  const handleSearchInput = event => {
    const options = event.target.value;
    setSearchInput(options);
  };
  
  const handleSortCategoryChange = event => {
    const options = event.target.value;
    setSelectedCategory(options);
  };

  const handleSortbyChange = event => {
    const options = event.target.value;
    setSelectedSortby(options);
  }

  const handleDelete = (event,video) => {
    Swal.fire({
      title: 'Are you sure to delete this favourite?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    })
    .then((result) => {
      if (result.value) {
        const newVideoList = [...favouriteList];
        const index = newVideoList.indexOf(video);
        if (index !== -1) {
          newVideoList.splice(index,1);
          setFavouriteList(newVideoList);
        }    
        VIDEO.deleteVideo(video.id)   
        .then(res => {
          Swal.fire({
            icon: "success",
            title: "favourite deleted successfully"
          }).then(() => {
            props.history.push("/favourite-list");
          });
        })
      } 
      else if (result.dismiss === Swal.DismissReason.cancel) {
        props.history.replace("/favourite-list");
      }
    })
  };

  const keyPress = e => {
    if (e.keyCode == 13) {
      filterThis();
    }
  };

  const filterThis = () => {
    setLoading(true);
    setCurrentPage(1);
    setOnFilter(searchInput + selectedType + new Date());
  };

  const clearFilter = () => {
    setLoading(true);
    setSearchInput("");
    setSelectedCategory("-- Select --");
    setSelectedSortby("-- Select --");
    setCurrentPage(1);
    setOnFilter(new Date());
  };

  const renderBookList = () => {
    return (
      <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
          {favouriteBook.length > 0 ? (
            <div style={{ overflowX: "auto", width: "100%" }}>
            <Table className={classes.table} aria-label="simple table">
             <TableHead>
                 <TableRow>
                     <TableCell className={classes.th}>ID</TableCell>
                     <TableCell style={{ width: 80 }} className={classes.th}></TableCell>
                     <TableCell className={classes.th}>Name</TableCell>
                     <TableCell className={classes.th}>Book Name</TableCell>
                     <TableCell className={classes.th}>Status</TableCell>
                     <TableCell className={classes.th}>Category</TableCell>
                     <TableCell className={classes.th}>Total view</TableCell>
                     <TableCell className={classes.th}>Action</TableCell>
                 </TableRow>
             </TableHead>
             <TableBody>
                 {favouriteBook.map(book => (
                     <TableRow
                        onClick={() => routeTo("view", book.id)}
                        className={classes.tr}
                        key={book.id}
                        >
                        <TableCell className={classes.td} component="th" scope="row">
                            {book.id}
                        </TableCell>
                        <TableCell className={classes.td}>
                            <img
                              src={
                                book.ebook_detail.image_url
                                  ? book.ebook_detail.image_url
                                  : book.avatar
                                  ? book.avatar
                                  : defaultCover
                              }
                              ali=""
                              width="40"
                              height="40"
                              style={{ borderRadius: 20 }}
                            />
                          </TableCell>
                        <TableCell className={classes.td}>{book.name}</TableCell>
                        <TableCell className={classes.td}>{book.ebook_detail.name}</TableCell>
                        <TableCell
                            style={{
                              color: 
                              book.ebook_detail.status.id == 1 ? "#FFA500" : "#4caf50" ,
                              fontWeight: "400"
                            }}
                            className={classes.td}>
                                {book.ebook_detail.status.name}
                          </TableCell>
                          <TableCell className={classes.td}>
                            {book.ebook_detail.categories.length > 0 
                              ? book.ebook_detail.categories.map((categories,i) => 
                                categories[i + 1] ? categories.name + ", "
                                : categories.name) : ""}
                          </TableCell>
                          <TableCell 
                            style={{
                                color: 
                                book.ebook_detail.total_view <= 10 ? "#FFA500" : "#4caf50" ,
                                fontWeight: "400",
                                align:"center"
                              }}
                            className={classes.td}>
                                {book.ebook_detail.total_view}
                          </TableCell>
                          <TableCell>
                              <IconButton aria-label="delete"
                                  onClick={(event) => {handleDelete(event.stopPropagation(),book) }} >
                                  <DeleteIcon />
                              </IconButton> 
                          </TableCell> 
                     </TableRow>
                 ))}
             </TableBody>    
            </Table>
            </div>
          ): null}
          </GridItem>
          </GridContainer>
    )
  }

    const renderVideoList = () => {
        return (
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
            {favouriteVideo.length > 0 ? (
              <div style={{ overflowX: "auto", width: "100%" }}>
              <Table className={classes.table} aria-label="simple table">
               <TableHead>
                   <TableRow>
                       <TableCell className={classes.th}>ID</TableCell>
                       <TableCell style={{ width: 80 }} className={classes.th}></TableCell>
                       <TableCell className={classes.th}>Name</TableCell>
                       <TableCell className={classes.th}>Video Name</TableCell>
                       <TableCell className={classes.th}>Status</TableCell>
                       <TableCell className={classes.th}>Category</TableCell>
                       <TableCell className={classes.th}>Total view</TableCell>
                       <TableCell className={classes.th}>Action</TableCell>
                   </TableRow>
               </TableHead>
               <TableBody>
                   {favouriteVideo.map(video => (
                       <TableRow
                          onClick={() => routeTo("view", video.id)}
                          className={classes.tr}
                          key={video.id}
                          >
                          <TableCell className={classes.td} component="th" scope="row">
                              {video.id}
                          </TableCell>
                          <TableCell className={classes.td}>
                              <img
                                src={
                                  video.educational_video_detail.image_url
                                    ? video.educational_video_detail.image_url
                                    : video.avatar
                                    ? video.avatar
                                    : defaultCover
                                }
                                ali=""
                                width="40"
                                height="40"
                                style={{ borderRadius: 20 }}
                              />
                            </TableCell>
                          <TableCell className={classes.td}>{video.user_id}</TableCell>
                          <TableCell className={classes.td}>{video.educational_video_detail.name}</TableCell>
                          <TableCell
                              style={{
                                color: 
                                video.educational_video_detail.status.id == 1 ? "#FFA500" : "#4caf50" ,
                                fontWeight: "400"
                              }}
                              className={classes.td}>
                                  {video.educational_video_detail.status.name}
                            </TableCell>
                            <TableCell className={classes.td}>
                              {video.educational_video_detail.categories.length > 0 
                                ? video.educational_video_detail.categories.map((categories,i) => 
                                  categories[i + 1] ? categories.name + ", "
                                  : categories.name) : ""}
                            </TableCell>
                            <TableCell 
                              style={{
                                  color: 
                                  video.educational_video_detail.total_view <= 10 ? "#FFA500" : "#4caf50" ,
                                  fontWeight: "400",
                                  align:"center"
                                }}
                              className={classes.td}>
                                  {video.educational_video_detail.total_view}
                            </TableCell>
                            <TableCell>
                                <IconButton aria-label="delete"
                                    onClick={(event) => {handleDelete(event.stopPropagation(),video) }} >
                                    <DeleteIcon />
                                </IconButton> 
                            </TableCell> 
                       </TableRow>
                   ))}
               </TableBody>    
              </Table>
              </div>
            ): null}
            </GridItem>
            </GridContainer>
        )
    }

    const renderClassList = () => {
        return (
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
            {favouriteClass.length > 0 ? (
              <div style={{ overflowX: "auto", width: "100%" }}>
              <Table className={classes.table} aria-label="simple table">
               <TableHead>
                   <TableRow>
                       <TableCell className={classes.th}>ID</TableCell>
                       <TableCell style={{ width: 80 }} className={classes.th}></TableCell>
                       <TableCell className={classes.th}>User Name</TableCell>
                       <TableCell className={classes.th}>Class Name</TableCell>
                       <TableCell className={classes.th}>Status</TableCell>
                       <TableCell className={classes.th}>Category</TableCell>
                       <TableCell className={classes.th}>Total view</TableCell>
                       <TableCell className={classes.th}>Action</TableCell>
                   </TableRow>
               </TableHead>
               <TableBody>
                   {favouriteClass.map(classs => (
                       <TableRow
                          onClick={() => routeTo("view", classs.id)}
                          className={classes.tr}
                          key={classs.id}
                          >
                          <TableCell className={classes.td} component="th" scope="row">
                              {classs.id}
                          </TableCell>
                          <TableCell className={classes.td}>
                              <img
                                src={
                                  classs.class_detail.images.url
                                    ? classs.class_detail.images.url
                                    : classs.avatar
                                    ? classs.avatar
                                    : defaultCover
                                }
                                ali=""
                                width="40"
                                height="40"
                                style={{ borderRadius: 20 }}
                              />
                            </TableCell>
                          <TableCell className={classes.td}>{classs.user_id}</TableCell>
                          <TableCell className={classes.td}>{classs.class_detail.name}</TableCell>
                          <TableCell
                              style={{
                                color: 
                                classs.class_detail.status.id == 1 ? "#FFA500" : "#4caf50" ,
                                fontWeight: "400"
                              }}
                              className={classes.td}>
                                  {classs.class_detail.status.name}
                            </TableCell>
                            <TableCell className={classes.td}>
                              {classs.class_detail.categories.length > 0 
                                ? classs.class_detail.categories.map((categories,i) => 
                                  categories[i + 1] ? categories.name + ", "
                                  : categories.name) : ""}
                            </TableCell>
                            <TableCell 
                              style={{
                                  color: 
                                  classs.class_detail.total_view <= 10 ? "#FFA500" : "#4caf50" ,
                                  fontWeight: "400",
                                  align:"center"
                                }}
                              className={classes.td}>
                                  {classs.class_detail.total_view}
                            </TableCell>
                            <TableCell>
                                <IconButton aria-label="delete"
                                    onClick={(event) => {handleDelete(event.stopPropagation(),classs) }} >
                                    <DeleteIcon />
                                </IconButton> 
                            </TableCell> 
                       </TableRow>
                   ))}
               </TableBody>    
              </Table>
              </div>
            ): null}
            </GridItem>
            </GridContainer>
        )
    }

    const renderCentreList = () => {
      for (let i =0;i<selectedUserName.length;i++) {
        console.log(selectedUserName[i].first_name);
      }
      console.log(selectedUserName);
      console.log(selectedUserName.length);
        return (
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
            {favouriteCentre.length > 0 ? (
              <div style={{ overflowX: "auto", width: "100%" }}>
              <Table className={classes.table} aria-label="simple table">
               <TableHead>
                   <TableRow>
                       <TableCell className={classes.th}>ID</TableCell>
                       <TableCell style={{ width: 80 }} className={classes.th}></TableCell>
                       <TableCell className={classes.th}>User Name</TableCell>
                       <TableCell className={classes.th}>Centre Name</TableCell>
                       <TableCell className={classes.th}>Centre Owner</TableCell>
                       <TableCell className={classes.th}>Status</TableCell>
                       <TableCell className={classes.th}>Category</TableCell>
                       <TableCell className={classes.th}>Action</TableCell>
                   </TableRow>
               </TableHead>
               <TableBody>
                   {favouriteCentre.map(center => (
                       <TableRow
                          onClick={() => routeTo("view", center.id)}
                          className={classes.tr}
                          key={center.id}
                          >
                          <TableCell className={classes.td} component="th" scope="row">
                              {center.id}
                          </TableCell>
                          <TableCell className={classes.td}>
                              <img
                                src={
                                  center.center_detail.images[0].url
                                    ? center.center_detail.images[0].url
                                    : center.avatar
                                    ? center.avatar
                                    : defaultCover
                                }
                                ali=""
                                width="40"
                                height="40"
                                style={{ borderRadius: 20 }}
                              />
                          </TableCell>
                          <TableCell className={classes.td}> 
                          {/* {book.categories.length > 0 
                              ? book.categories.map((categories,i) => 
                                categories[i + 1] ? categories.name + ", "
                                : categories.name) : ""}  */}
                              {
                              selectedUserName.length > 0 
                                ? 
                                selectedUserName.map((name,i) =>
                                name[i + 1] ? name.first_name 
                                + " " + name.last_name
                                : "") : ""}
                                {/* : ""}  */}
                                {/* {center.user_id} */}
                                {/* {selectedUserName[0].first_name} {selectedUserName[0].last_name} */}
                          </TableCell>
                          <TableCell className={classes.td}>{center.center_detail.name}</TableCell>
                          <TableCell className={classes.td}>
                                  {center.center_detail.center_owner_detail[0].user_detail.first_name} {center.center_detail.center_owner_detail[0].user_detail.last_name}
                          </TableCell>
                          <TableCell
                              style={{
                                color: 
                                center.center_detail.status.id == 1 ? "#FFA500" : "#4caf50" ,
                                fontWeight: "400"
                              }}
                              className={classes.td}>
                                  {center.center_detail.status.name}
                            </TableCell>
                            <TableCell className={classes.td}>
                              {center.center_detail.categories.length > 0 
                                ? center.center_detail.categories.map((categories,i) => 
                                  categories[i + 1] ? categories.name + ", "
                                  : categories.name) : ""}
                            </TableCell>
                            
                            <TableCell>
                                <IconButton aria-label="delete"
                                    onClick={(event) => {handleDelete(event.stopPropagation(),center) }} >
                                    <DeleteIcon />
                                </IconButton> 
                            </TableCell> 
                       </TableRow>
                   ))}
               </TableBody>    
              </Table>
              </div>
            ): null}
            </GridItem>
            </GridContainer>
        )
    }

    const renderAllList = () => {
      return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
            {favouriteAll.length > 0 ? (
              <div style={{ overflowX: "auto", width: "100%" }}>
              <Table className={classes.table} aria-label="simple table">
               <TableHead>
                   <TableRow>
                       <TableCell className={classes.th}>ID</TableCell>
                       <TableCell className={classes.th}>User Name</TableCell>
                       <TableCell className={classes.th} style={{textAlign:"center"}}>Book</TableCell>
                       <TableCell className={classes.th} style={{textAlign:"center"}}>Centre</TableCell>
                       <TableCell className={classes.th} style={{textAlign:"center"}}>Class</TableCell>
                       <TableCell className={classes.th} style={{textAlign:"center"}}>Video</TableCell>
                       <TableCell className={classes.th} style={{textAlign:"center"}}>Action</TableCell>
                   </TableRow>
               </TableHead>
               <TableBody>
                   {favouriteAll.map(all => (
                        <TableRow
                      //     onClick={() => routeTo("view", all.id)}
                          className={classes.tr}
                          key={all.id}
                          >
                          <TableCell className={classes.td} component="th" scope="row" style={{width:"8%"}}>
                              {all.id}
                          </TableCell>
                          <TableCell className={classes.td} style={{width:"25%"}}>{all.user_id}</TableCell>
                          <TableCell className={classes.td} style={{width:"13%",textAlign:"center"}}>
                            {all.ebook_id != null ? ( 
                              <Icon aria-label="check" style={{color:"#4caf50",textAlign:"center"}}>
                                <CheckIcon />
                              </Icon>
                            ):(
                              <Icon aria-label="check" style={{color:"#DC143C", textAlign:"center"}}>
                                <ClearIcon />
                              </Icon>
                            )} 
                          </TableCell>
                          <TableCell className={classes.td} style={{width:"13%",textAlign:"center"}}>
                            {all.center_id != null ? ( 
                              <Icon aria-label="check" style={{color:"#4caf50",textAlign:"center"}}>
                                <CheckIcon />
                              </Icon>
                            ):(
                              <Icon aria-label="check" style={{color:"#DC143C", textAlign:"center"}}>
                                <ClearIcon />
                              </Icon>
                            )} 
                          </TableCell>
                          <TableCell className={classes.td} style={{width:"13%",textAlign:"center"}}>
                            {all.class_id != null ? ( 
                              <Icon aria-label="check" style={{color:"#4caf50",textAlign:"center"}}>
                                <CheckIcon />
                              </Icon>
                            ):(
                              <Icon aria-label="check" style={{color:"#DC143C", textAlign:"center"}}>
                                <ClearIcon />
                              </Icon>
                            )} 
                          </TableCell>
                          <TableCell className={classes.td} style={{width:"13%",textAlign:"center"}}>
                            {all.educational_video_id != null ? ( 
                              <Icon aria-label="check" style={{color:"#4caf50",textAlign:"center"}}>
                                <CheckIcon />
                              </Icon>
                            ):(
                              <Icon aria-label="check" style={{color:"#DC143C", textAlign:"center"}}>
                                <ClearIcon />
                              </Icon>
                            )} 
                          </TableCell>                      
                          {/* <TableCell className={classes.td}>
                            {all.created_at.substring(0, 10) +
                              " " +
                              all.created_at.substring(11, 19)}
                          </TableCell> */}
                          <TableCell className={classes.td} style={{width:"15%",textAlign:"center"}}>
                              <IconButton aria-label="delete"
                                  onClick={(event) => {handleDelete(event.stopPropagation(),all) }} >
                                  <DeleteIcon />
                              </IconButton> 
                          </TableCell> 
                       </TableRow>
                   ))}
               </TableBody>    
              </Table>
              </div>
            ): null}
            </GridItem>
            </GridContainer>
      )
    }

  const paramPass = {
    page: currentPage,
    search: searchInput,
    type:selectedType
  };

  if (route.action == "add") {
    return (
      <Redirect
        to={{
          pathname: "/favourite-list/add",
          state: paramPass
        }}
      />
    );
  } else if (route.action == "view") {
    return (
      <Redirect
        to={{
          pathname: "/favourite-list/" + route.id,
          state: paramPass
        }}
      />
    );
  }

  let typetitle = "";
  if (selectedType == 300) {
      typetitle = "e-book";
  }
  else if (selectedType == 100) {
      typetitle = "Centre";
  }
  else if (selectedType == 200) {
    typetitle = "Class";
  }
  else if (selectedType == 400) {
    typetitle = "Educational Video";
  }

  return loading ? (
    <div className={classes.load}>
      <CircularProgress style={{ fontSize: 30, color: themeColor }} />
    </div>
  ) : (
    <GridContainer>
       <GridItem style={{ marginBottom: 20 }} xs={12} sm={12} md={12}>
        Type :
        <Select
          style={{ marginLeft: 10, width: 150 }}
          className={classes.select}
          id="type"
          name="type"
          variant="outlined"
          value={selectedType}
          onChange={event => {
            setSelectedType(event.target.value);
          }}
          input={<Input id="type" />}
        >
          {listtype.map(option => (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
           ))}
        </Select>
      </GridItem>

      <GridItem xs={12} sm={12} md={12}>
        <div
          id="table"
          ref={node => {
            myRef = node;
          }}>
          <Card>
          <CardHeader color="warning" style={{ width: "fit-content" }}>
            <h4 className={classes.cardTitleWhite}>Favourite {typetitle} List </h4>
          </CardHeader>
            <CardBody>
              <GridContainer style={{ paddingBottom: 10 }}>
                <GridItem xs={6} sm={6} md={5}>
                  <TextField
                    variant="standard"
                    margin="normal"
                    id="search"
                    label="Search"
                    name="search"
                    placeholder={"user name"}
                    fullWidth
                    onKeyDown={keyPress}
                    value={searchInput}
                  //   onkeyup={searchInput => {data.filter(datum=>{
                  //     return datum.username.indexOf(searchInput) !== -1
                  // })}}
                    onChange={handleSearchInput}
                    InputProps={{
                      classes: {
                        underline: classes.underline,
                        disabled: classes.disabled
                      }
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.cssLabel,
                        focused: classes.cssFocused
                      }
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={4} md={7}
                  style={{ display: "block", marginTop: 25, textAlign: "right" }}>
                  <Button
                    variant="contained"
                    type="submit"
                    style={{ backgroundColor: themeColor, color: "white", marginBottom: 8 }}
                    className={classes.submit}
                    onClick={filterThis}>
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: themeColor,
                      color: "white",
                      marginLeft: 8,
                      marginBottom: 8
                    }}
                    className={classes.submit}
                    onClick={clearFilter}>
                    Reset
                  </Button>
                </GridItem>
              </GridContainer>
              {selectedType === "100" ? (
                  renderCentreList()
              ): selectedType === "200" ? (
                  renderClassList()
              ): selectedType === "300" ? (
                  renderBookList()
              ): selectedType === "400" ? (
                  renderVideoList()
              ) : (
                  renderAllList()
              )}
              {favouriteCentre.length > 0 || favouriteClass.length > 0 || favouriteBook.length > 0 || favouriteVideo.length > 0 || favouriteAll.length > 0 ? (
                  <div
                      style={{ display: "inline-flex", width: "100%", justifyContent: "flex-end" }}>
                      <div style={{ fontSize: 13 }}>
                          Page :
                          <Select
                            style={{
                              marginLeft: 10,
                              width: 60,
                              fontSize: 13,
                              textAlign: "center",
                              marginTop: 12
                            }}
                            className={classes.select}
                            id="type"
                            name="type"
                            variant="outlined"
                            value={currentPage}
                            onChange={e => goToPage(e)}
                            input={<Input id="type" />}
                            renderValue={selected => selected}
                            MenuProps={MenuProps}>
                            {pageArr.map(page => (
                              <MenuItem key={page} value={page}>
                                <ListItemText primary={page} />
                              </MenuItem>
                            ))}
                          </Select>
                      </div>
                      <TablePagination
                          component="div"
                          rowsPerPageOptions={[]}
                          count={pagination.total}
                          rowsPerPage={10}
                          page={currentPage - 1}
                          onChangePage={handleChangePage}
                      />
                  </div>
              ) :  (
                  <div style={{ paddingTop: 30, textAlign: "center" }}>
                    <Typography style={{ fontWeight: "inherit" }}>No Data found</Typography>
                  </div>
                )}
              
            </CardBody>
          </Card>
        </div>
      </GridItem>
    </GridContainer>
  );
}